import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardUtils } from '@/features/dashboard/utils/dashboardUtils';
import { cn } from '@/lib/utils';
import DashboardManagedByChart from '@/features/dashboard/components/DashboardManagedBy/DashboardManagedByChart';
import { useDashboardManagedByApi } from '@/features/dashboard/hooks/useDashboardManagedByApi';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import DashboardManagedByBlockSkeleton from './DashboardManagedByBlockSkeleton';

type Props = {
	isMobile?: boolean;
};

const DashboardManagedByBlock: FC<Props> = ({ isMobile }) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const { managedByData, isLoadingManagedByData } =
		useDashboardManagedByApi();

	const {
		icon: Icon,
		iconClasses,
		iconBgClasses,
		chartMainColor,
		chartSecondaryColor,
	} = DashboardUtils.getAllChartsConfig('managedBy');

	return (
		<>
			{!!managedByData && (
				<div
					className={cn(
						'p-6 flex grow  flex-col gap-6 border border-popover-100 rounded-2.5xl bg-popover-10 select-none',
						isMobile && 'p-0 border-0 bg-popover-30 gap-4',
					)}>
					{!isMobile && (
						<div className='flex items-center gap-4'>
							<div
								className={cn(
									'size-8 flex items-center justify-center rounded-semi-xl',
									iconBgClasses,
								)}>
								<Icon className={iconClasses} />
							</div>
							<h4 className='text-xl font-medium'>
								{t(
									'main.dashboard.components.chart.managedBy.title',
								)}
							</h4>
						</div>
					)}
					<div className='grow-1 h-81 flex flex-col items-center justify-center gap-1'>
						<DashboardManagedByChart
							data1={{
								value: managedByData?.hotel ?? 0,
								color: chartMainColor,
							}}
							data1Name={t(
								'main.dashboard.components.chart.managedBy.chartOption1',
							)}
							data2={{
								value: managedByData?.owners ?? 0,
								color: chartSecondaryColor,
							}}
							data2Name={t(
								'main.dashboard.components.chart.managedBy.chartOption2',
							)}
						/>
					</div>
					<Button
						variant={'outline'}
						className='w-full text-sm font-medium'
						onClick={() => navigate('/apartments')}>
						{t(
							'main.dashboard.components.chart.managedBy.seeMoreButton',
						)}
					</Button>
				</div>
			)}
			{!!isLoadingManagedByData && <DashboardManagedByBlockSkeleton />}
		</>
	);
};

export default DashboardManagedByBlock;
